module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c37c766fb74ec35d5ca9d9c61f10e681.png";